export const LOGOUT_REQUEST = '/api/v1/auth/logout/';
export const LOGIN_REQUEST = '/api/v1/auth/login/';
export const RESET_PASSWORD_REQUEST = '/api/v1/auth/password/reset/';
export const CHANGE_PASSWORD_REQUEST = '/api/v1/auth/password/request/';
export const USER_REQUEST_URL = '/api/v1/user/';
export const GET_CURRENT_USER_REQUEST = '/api/v1/user/current/';
export const GET_APP_ROLES = '/api/v1/appRole/';
export const PRODUCT_URL = '/api/v1/product/';
export const DELETE_PRODUCT = '/api/v1/product/';
export const PROPERTIES_URL = '/api/v1/productScheme/property/';
export const FORMS_URL = '/api/v1/productScheme/form/';
export const RECIPES_URL = '/api/v1/recipe/';
export const RECIPE_TYPE_COOKING_STEP_URL = '/api/v1/recipeType/';
export const PREFERENCE_URL = '/api/v1/preference/';
export const PREFERENCE_GROUP_URL = '/api/v1/preferenceScheme/group/';
export const RECIPE_SCHEME_URL = '/api/v1/recipeScheme/ingredient/';
export const GENERATION_TRACES_URL = '/api/v1/admin/generation-traces/';
export const REFERENCE_BOOKS_URL = '/api/v1/productScheme/reference-book/';
export const REFERENCE_TABLE_URL = '/api/v1/productScheme/reference-table/';
export const GRAIN_LIQUID_RATIO_URL = '/api/v1/productScheme/grain-liquid-ratio/';
export const SVG_ASSET_URL = '/api/v1/svg-asset/';
export const PHRASE_URL_PART = '/phrase/';
export const CATEGORY_URL_PART = '/category/';
export const FORM_URL_PART = '/form/';
export const PROPERTY_URL_PART = '/property/';

export const getFetchRequest = (url, successCallback, errorCallback, withoutJSON = false) => {
    fetch(`${url}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
    }).then(response => {
        if(!withoutJSON) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        successCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const postFetchRequest = (url, body, successCallback, errorCallback, withoutJSON = false) => {
    fetch(`${url}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    }).then(response => {
        if(body && !withoutJSON) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        successCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const patchFetchRequest = (url, body, successCallback, errorCallback, withoutJSON = false) => {
    fetch(`${url}`, {
        credentials: 'include',
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    }).then(response => {
        if(body && !withoutJSON) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        successCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const putFetchRequest = (url, body, successCallback, errorCallback, withoutJSON = false) => {
    fetch(`${url}`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    }).then(response => {
        if(body && !withoutJSON) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        successCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const deleteFetchRequest = (url, successCallback, errorCallback, body = null) => {
    fetch(`${url}`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        body: body ? JSON.stringify(body) : null,
    }).then(response => {
        successCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const getSyncFetchRequest = async (url) => {
    const result = await fetch(`${url}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
    });
    return await result.json();
};
